export default {
  isSaved: false,
};


// WEBPACK FOOTER //
// ./src/modules/bids/vuex/state.js